module.exports = __webpack_public_path__ + "img/logo-zh@3x.23661a43.png";